// src/components/Toast.ts
import Swal, { SweetAlertIcon } from "sweetalert2";

interface ToastOptions {
  type?: SweetAlertIcon; // "success" | "error" | "warning" | "info" | "question"
  message: string;
  timer?: number;
  position?: "top-end" | "top" | "center" | "bottom" | "bottom-end";
}

export const showToast = ({
  type = "info",
  message,
  timer = 2000,
  position = "center",
}: ToastOptions) => {
  Swal.fire({
    position,
    icon: type,
    title: message,
    showConfirmButton: false,
    timer,
    toast: true, // makes it behave like a toast
  });
};

export const showErrorToast = (message: string) => {
  Swal.fire({
    position: "center",
    icon: "error",
    title: message,
    showConfirmButton: false,
    timer: 3000,
    toast: true, // makes it behave like a toast
  });
};

export const showSuccessToast = (message: string) => {
  Swal.fire({
    position: "center",
    icon: "success",
    title: message,
    showConfirmButton: false,
    timer: 2000,
    toast: true, // makes it behave like a toast
  });
};
